module.exports = __webpack_public_path__ + "static/media/address_image.3b021f8f.svg";